<template>
  <b-dropdown
    ref="dropdown"
    variant="link"
    :text="trans('zoom_meeting_url')"
    toggle-class="p-0 btn-sm"
    class="ml-2"
    :disabled="disabled"
  >
    <b-dropdown-text v-if="!!error" variant="danger">
      {{ error }}
    </b-dropdown-text>
    <b-dropdown-text v-if="busy && items == null">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </b-dropdown-text>
    <b-dropdown-item v-for="item in items" v-bind:key="item.uuid" :disabled="disabled || busy" @click="onClickItem(item)">
      <span>{{ item.name }}, {{ moment(item.start).format('LLL') }}</span>
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-text>
      <b-row>
        <b-col class="text-center">
          <b-button variant="link" class="p-0" :disabled="disabled || busy || page == 1" @click="onPreviousPage">
            <i class="fa fa-fw fa-chevron-left"></i>
          </b-button>
        </b-col>
        <b-col class="text-center">
          <b-button variant="link" class="p-0" :disabled="disabled || busy || page == last_page" @click="onNextPage">
            <i class="fa fa-fw fa-chevron-right"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
  export default {
    props: {
      organization: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
        moment: moment,
        busy: false,
        error: null,
        items: null,
        selected: null,
        total: null,
        page: 1,
        last_page: 1,
        per_page: 10,
      }
    },
   	methods: {
      onPreviousPage(bvEvt) {
        if (this.page <= 1) return
        this.page -= 1
        this.fetch()
      },
      onNextPage(bvEvt) {
        if (this.page >= this.last_page) return
        this.page += 1
        this.fetch()
      },
      onClickItem(item) {
        this.selected = item
        this.$emit('input', item)
      },
   	  fetch() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/zoom/meeting/api?per_page=${this.per_page}&page=${this.page}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.total = response.data.total
          this.page = response.data.current_page
          this.last_page = response.data.last_page
          this.items = response.data.data
          this.$emit('loaded')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
   	  },
   	},
   	mounted() {
      window.zoomDropdown = this
      this.fetch()
   	},
  }
</script>